import { api, ENDPOINTS } from '@/api/config';
import type { IaqSystemResponseData, IaqFilters } from './types';

/**
 * Get IAQ subsystem data
 */
export async function getIaqSystem(filters?: IaqFilters): Promise<IaqSystemResponseData> {
  const params = new URLSearchParams();
  
  if (filters?.expand) {
    params.append('expand', filters.expand);
  }

  const url = `${ENDPOINTS.IAQ}${params.toString() ? '?' + params.toString() : ''}`;
  
  const response = await api.get(url);
  return response;
}